// extracted by mini-css-extract-plugin
module.exports = {"advice":"search_advice-module__advice--3Y-kf","text":"search_advice-module__text--15uOt","link":"search_advice-module__link--2y1Bv"};